<template>
  <footer id="foot">
    <div class="w font">
      <div class="footBox1">
        <div class="con1">
          <div>展恒基金（总部）地址：北京市朝阳区北四环中路27号院5号楼6层0615A</div>
          <div>客服热线：400-818-8000</div>
          <div>客服邮箱：CALLCENTER@myfp.cn</div>
          <div>Copyright©2004-2021 北京展恒基金销售股份有限公司版权所有</div>
        </div>
        <ul class="con2">
          <li>
            <img src="https://www.myfund.com/images/weixin-gongzhonghao.jpg" alt="" class="codeIg">
            <span>展恒基金</span>
            <span>微信公众号</span>
          </li>
          <li>
            <img src="https://www.myfund.com/images/gongmu-wxkefu.jpg" alt="" class="codeIg">
            <span>公募基金</span>
            <span>微信客服号</span>
          </li>
          <li>
            <img src="https://www.myfund.com/images/simu-wxkefu.jpg" alt="" class="codeIg">
            <span>私募基金</span>
            <span>微信客服号</span>
          </li>
          <li>
            <img src="https://www.myfund.com/images/APP-download.jpg" alt="" class="codeIg">
            <span>展恒基金</span>
            <span>APP下载</span>
          </li>
        </ul>
      </div>
      <div class="footBox2">
        风险提示：理财顾问禁止以展恒基金的名义销售非展恒基金代销的产品，否则给客户或展恒基金公司带来的资产或名誉的损失，将承担相应的责任。
      </div>
    </div>
  </footer>

</template>

<script>
export default {
  name: "lv-footer",
}
</script>

<style lang="less" scoped>
footer {
  position: relative;
  width: 100%;
  min-width: 1200px;
  height: 186px;
  margin: 0 auto;
  background: @color;
  .footBox1 {
    width: 100%;
    height: 130px;
    position: relative;
    .con1 {
      width: 460px;
      height: 100%;
      line-height: 25px;
      float: left;
      position: relative;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding-top: 22px;
    }
    .con2 {
      width: 735px;
      height: 100%;
      float: right;
      position: relative;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding-top: 25px;
      font-size: 12px;
      li {
        width: 25%;
        height: 100%;
        float: left;
        position: relative;
        .codeIg {
          width: 94px;
          height: 94px;
          float: left;
        }
        span:nth-of-type(1) {
          position: absolute;
          margin: auto;
          left: 101px;
          top: 29px;
        }
        span:nth-of-type(2) {
          position: absolute;
          margin: auto;
          left: 101px;
          top: 47px;
        }
      }
    }
  }
  .footBox2 {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 7px;
  }
}
.font {
  font-size: 14px;
  font-weight: 400;
  color: @wColor;
}
</style>
